import { Box, Avatar, styled } from '@mui/material';
import React from 'react';
import { Person } from '@mui/icons-material';

const StyledAvatar = styled(Avatar)(({ theme, size }) => ({
	width: size,
	height: size,
	backgroundColor: theme.palette.primary.main
}));

const UserAvatar = ({ avatar, size = 40 }) => {
	return (
		<StyledAvatar size={size} src={avatar}>
			<Person />
		</StyledAvatar>
	);
};

export default UserAvatar;
